import { useEffect, type ReactNode } from "react";
import { Link } from "react-router";
import { BRAND } from "@hik/i18n";
import { Icon } from "./Icon";

/** Sayfa başlığı: tek h1, bir ana eylem; belge başlığı güncellenir (ekran okuyucu ve sekme için). */
export function PageHeader({
  title,
  lead,
  actions,
  back,
  kicker,
}: {
  title: string;
  lead?: ReactNode;
  actions?: ReactNode;
  back?: { to: string; label: string };
  kicker?: ReactNode;
}) {
  useEffect(() => {
    // Destek oturumunda sekme başlığı da ayırt edilir ("Destek · Çalışanlar · 21ik").
    const prefix = document.documentElement.dataset.support === "1" ? "Destek · " : "";
    document.title = `${prefix}${title} · ${BRAND.name}`;
  }, [title]);
  return (
    <header className="page-header">
      {back && (
        <Link to={back.to} className="page-header__back">
          <Icon name="arrow-left" size={16} />
          <span>{back.label}</span>
        </Link>
      )}
      <div className="page-header__row">
        <div className="page-header__text">
          {kicker && <p className="page-header__kicker">{kicker}</p>}
          <h1 className="page-header__title">{title}</h1>
          {lead && <p className="page-header__lead">{lead}</p>}
        </div>
        {actions && <div className="page-header__actions">{actions}</div>}
      </div>
    </header>
  );
}

/** Başlıklı bölüm: solda başlık/özet, sağda içerik (geniş ekranda), dar ekranda alt alta. */
export function Section({ title, aside, children, id }: { title: string; aside?: ReactNode; children: ReactNode; id?: string }) {
  return (
    <section className="section" aria-labelledby={id ?? undefined}>
      <div className="section__head">
        <h2 className="section__title" id={id}>
          {title}
        </h2>
        {aside && <div className="section__aside">{aside}</div>}
      </div>
      <div className="section__body">{children}</div>
    </section>
  );
}

export function DefinitionList({ items }: { items: { term: ReactNode; value: ReactNode }[] }) {
  return (
    <dl className="deflist">
      {items.map((it, i) => (
        <div key={i} className="deflist__row">
          <dt>{it.term}</dt>
          <dd>{it.value ?? "—"}</dd>
        </div>
      ))}
    </dl>
  );
}
